import { render, staticRenderFns } from "./classroom-edit.vue?vue&type=template&id=28b5cd64&scoped=true"
import script from "./classroom-edit.vue?vue&type=script&lang=js"
export * from "./classroom-edit.vue?vue&type=script&lang=js"
import style0 from "./classroom-edit.vue?vue&type=style&index=0&id=28b5cd64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b5cd64",
  null
  
)

export default component.exports